<script lang="ts">
	import HomeButtons from './HomeButtons.svelte';
</script>

<div class="flex flex-col">
	<div class="pt-8 self-center flex flex-col">
		<h1 class="text-8xl">Woad</h1>
		<h2 class="text-4xl mb-8">stone to stone</h2>
		<HomeButtons />
	</div>
</div>
